import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function CaseStudies() {
  const swiperConfig = {
    loop: true,
    speed: 600,
    autoplay: {
      delay: 5000,
    },
    slidesPerView: "auto",
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 1,
      },
    },
  };
  return (
    <div>
      <section id="testimonials" class="testimonials section light-background">
        {/* Section Title */}
        <div class="container section-title" data-aos="fade-up">
          <h2>Case Studies of success</h2>
          {/* <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p> */}
        </div>
        {/* End Section Title */}

        <div class="container" data-aos="fade-up" data-aos-delay="100">
          <div class="row gy-4">
            <div class="col-lg-3" data-aos="fade-up" data-aos-delay="200">
              <div class="card" style={{height:'100%'}}>
                <img
                  src="../assets/img/nykka.jpg"
                  class="card-img-top"
                  alt="nykaa"
                />
                <div class="card-body">
                  <p class="card-text" style={{textAlign:'center'}}>
                    Nykaa, a pioneer in India's online beauty and personal care
                    market, went public in 2021. Investors who secured pre-IPO
                    shares reaped exceptional returns as the company’s valuation
                    soared post-listing. Nykaa's strong market position,
                    consistent revenue growth, and innovative approach made it a
                    standout success in the pre-IPO segment.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3" data-aos="fade-up" data-aos-delay="200">
              <div class="card" style={{height:'100%'}}>
                <img
                  src="../assets/img/policy_bazaar1.jpg"
                  class="card-img-top"
                  alt="policybazar"                 
                />
                <div class="card-body">
                  <p class="card-text" style={{textAlign:'center'}}>
                  PolicyBazaar, India’s leading online insurance aggregator, attracted significant investor interest before its IPO in 2021. 
                  Early investors acquired pre-IPO shares at attractive valuations, and the company’s strong brand presence and business growth led to a substantial surge in value post-listing. This success story demonstrates the potential of investing in disruptive, tech-driven businesses. Pre-IPO price – Rs. 940
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3" data-aos="fade-up" data-aos-delay="200">
              <div class="card" style={{height:'100%'}}>
                <img
                  src="../assets/img/delhivery.png"
                  class="card-img-top"
                  alt="delhivery"                 
                />
                <div class="card-body">
                  <p class="card-text" style={{textAlign:'center'}}>
                  Delhivery, a leading logistics and supply chain services company, demonstrated remarkable growth before its IPO in 2022. Early investors who participated in the pre-IPO round benefitted from the company's strong fundamentals, robust market demand, and innovative solutions, resulting in substantial post-listing gains.                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3" data-aos="fade-up" data-aos-delay="200">
              <div class="card" style={{height:'100%'}}>
                <img
                  src="../assets/img/zomato.jpg"
                  class="card-img-top"
                  alt="delhivery"                 
                />
                <div class="card-body service-item">
                  <p class="card-text" style={{textAlign:'center'}}>
                  Zomato, one of India's largest food delivery and restaurant discovery platforms, went public in 2021. Pre-IPO investors, including venture capital firms and institutional investors, saw exponential growth in their investments. The IPO was oversubscribed, and the stock price rose significantly, highlighting the immense potential of early investments in high-growth tech companies pre-IPO investments.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Testimonials Section */}
    </div>
  );
}

export default CaseStudies;
